export const PREFIX = process.env.REACT_APP_API_URL || '';
export const JWT_STORAGE_KEY = 'jwt';

export const COLOR_SUCCESS = '#52c41a';
export const COLOR_WARNING = '#faad14';
export const COLOR_DANGER = '#ff4d4f';

export const getAllProfessionsUrl = '/professions/';
export const getAllActivitiesUrl = '/activities/';
export const getAllBindActivitiesUrl = '/activities/relations/';
export const getAllDivisionsUrl = '/divisions/';
export const getAllRulesUrl = '/rules/';
export const createRulesManyUrl = '/rules/to_many';
export const deleteRulesManyUrl = '/rules/to_many';
export const getAllModulesUrl = '/training_modules/';
export const getAllInstructionsUrl = '/instructions/';
export const getAllUsersUrl = '/users';
export const uploadUsersUrl = '/users/upload';
export const uploadSoutUrl = '/workplaces/import';
export const getAllWorkplacesUrl = '/workplaces/';
export const getAllCompensationsUrl = '/compensations/';
export const bindWorkplaceActivitiesUrl = (id) => `/workplaces/${id}/activities`;
export const bindWorkplaceCompensationsUrl = (id) => `/workplaces/${id}/compensations`;
export const mcpMyKeyUrl = '/mcp-keys/my';
export const mcpKeysUrl = '/mcp-keys/';
export const rotateMcpKeyUrl = (id) => `/mcp-keys/${id}/rotate`;
export const revokeMcpKeyUrl = (id) => `/mcp-keys/${id}`;
export const registerUrl = '/auth/register';
export const loginUrl = '/auth/jwt/login';
export const getAllUsersPaginatedUrl = '/users/paginated';
export const getAllUsersPaginatedLightUrl = '/users/paginated_light';
export const getAllUsersInitialsUrl = 'users/with_initials';
export const getAllMaterialTypesUrl = '/material_types/';
export const getSizNeedByMaterialTypeUrl = '/siz_need/by_material_type';
export const getSizNeedByEmployeeUrl = '/siz_need/by_employee';
export const getAllNormsUrl = '/norms/';
export const getAllMaterialsUrl = '/materials/';
export const createMaterialsBulkUsersUrl = '/materials/bulk_users';
export const getAllMaterialsPaginatedUrl = '/materials/paginated';
export const getAllTestsUrl = '/tests/tests';
export const getAllHistoriesPaginatedUrl = '/histories/paginated?type__in=TEST_EXECUTION';
export const getAllFileTemplatesUrl = '/file_templates/';
export const templatesRegistryUrl = '/file_templates/registry';
export const getAllTemplateBindsUrl = '/template_binds/';
export const createTemplateBindsManyUrl = '/template_binds/to_many';
export const deleteTemplateBindsManyUrl = '/template_binds/to_many';
export const getRosterBindsUrl = '/roster_binds/';
export const applyRosterBindsUrl = '/roster_binds/apply';
export const getDocumentDeadlines = 'documents/deadlines';
export const getDocumentDeadlinesTable = 'documents/deadlines_table';
export const getAllDocumentsUrl = '/documents';
export const issueSizGenerateZipUrl = '/documents/issue_siz_generate_zip';
export const downloadsUrl = '/downloads/';
export const downloadsSummaryUrl = '/downloads/summary';
export const downloadLinkUrl = (id) => `/downloads/${id}/link`;
export const downloadUrl = (id) => `/downloads/${id}`;


export const DEADLINE_WARNING_DAYS = 15;

export const DEADLINE_STATUS_COLORS = {
	ok: COLOR_SUCCESS,
	warning: COLOR_WARNING,
	overdue: COLOR_DANGER,
	no_date: '#d9d9d9'
};

export const DEADLINE_STATUS_LABELS = {
	ok: 'Ок',
	warning: 'Скоро истекает',
	overdue: 'Просрочено',
	no_date: 'Нет данных'
};

export const SIZ_NEED_STATUS_COLORS = {
	covered: COLOR_SUCCESS,
	need: COLOR_DANGER,
	norm: '#94a3b8'
};

export const SIZ_NEED_STATUS_LABELS = {
	covered: 'Выдано',
	need: 'Необходимо',
	norm: 'Норма'
};

export const WORKPLACE_TYPE_LABELS = {
	attested: 'Аттестовано',
	similar: 'Аналогичное',
	declared: 'Декларировано'
};

export const WORKING_CONDITIONS_CLASSES = ['1', '2', '3.1', '3.2', '3.3', '3.4', '4'];

export const unitsOfMeasurements = [
	{ value: 'шт', label: 'шт' },
	{ value: 'пар', label: 'пар' },
	{ value: 'мл', label: 'мл' },
	{ value: 'гр', label: 'гр' },
	{ value: 'компл', label: 'компл' }
];

// Copy of SIZE_TYPE_LABELS + HEIGHT_FEATURE_LABEL in
// src/database/models/material_types.py — keep the wording identical.
// The Excel employee import matches columns by exact header text and silently
// skips headers it does not recognise, so a label changed on one side only
// imports people without their sizes and reports no error.
export const SIZE_FEATURE_LABELS = {
	clothing_size: 'Размер одежды',
	shoe_size: 'Размер обуви',
	head_size: 'Размер голов. убора',
	mask_size: 'Размер маски',
	gloves_size: 'Размер перчаток',
	mitten_size: 'Размер рукавиц',
	height: 'Рост'
};

// Options for the PPE type editor: every size feature except height, which is
// a property of the employee rather than a size a material type can have.
export const typeSizes = Object.entries(SIZE_FEATURE_LABELS)
	.filter(([key]) => key !== 'height')
	.map(([value, label]) => ({ value, label }));


export const OrganizationDocumentsValue = 'doc_org';
export const OrganizationDocumentsLabel = 'Документы для организации';
